<form [formGroup]="formGroup" autocomplete="off">
    <mat-tab-group [selectedIndex]="selectedTab" (selectedTabChange)="onSelectedTabChange($event)">

        <!-- FISICAL PERSON -->
        <div *ngIf="ndg.typology == 'FIS'">
            <!-- NDG DATA -->
            <mat-tab label="{{ 'survey.new.ndg-data.title' | translate }}">
                <ndg-data-fis [ndg]="ndg" (complete)="onNdgDataComplete($event)"></ndg-data-fis>
            </mat-tab>

            <!-- NEEDS -->
            <mat-tab label="{{ 'survey.new.needs-fis.title' | translate }}" [disabled]="true">
                <needs-fis *ngIf="surveyId" [surveyId]="surveyId" (complete)="onNeedsComplete($event)"></needs-fis>
            </mat-tab>

            <!-- PROTECTION -->
            <mat-tab label="{{ 'survey.new.protection.title' | translate }}" [disabled]="true" *ngIf="surveyNeedsEmit?.protection">
                <protection [surveyId]="surveyId" [ndgData]="ndgDataEmit" (complete)="onProtectionComplete()"></protection>
            </mat-tab>

            <!-- SAVINGS -->
            <mat-tab label="{{ 'survey.new.savings.title' | translate }}" [disabled]="true" *ngIf="surveyNeedsEmit?.savings">
                <savings [surveyId]="surveyId" [surveyNeeds]="surveyNeedsEmit" [ndgData]="ndgDataEmit" (complete)="onSavingsComplete()"></savings>
            </mat-tab>

            <!-- SAVINGS SHORT LIST -->
            <mat-tab label="{{ 'survey.new.savings-short-list.title' | translate }}" [disabled]="true" *ngIf="surveyNeedsEmit?.savings && savingsCompleted">
                <savings-short-list [surveyId]="surveyId" (complete)="onSavingsShortListComplete()"></savings-short-list>
            </mat-tab>

            <!-- PREVIDENCE -->
            <mat-tab label="{{ 'survey.new.previdence.title' | translate }}" [disabled]="true" *ngIf="!surveyNeedsEmit?.savings && surveyNeedsEmit?.previdence">
                <previdence [surveyId]="surveyId" [ndgData]="ndgDataEmit" (complete)="onPrevidenceComplete()"></previdence>
            </mat-tab>
        </div>

        <!-- GIURIDICAL PERSON -->
        <div *ngIf="ndg.typology == 'GIU'">
            <!-- NDG DATA -->
            <mat-tab label="{{ 'survey.new.ndg-data.title' | translate }}">
                <ndg-data-giu [ndg]="ndg" (complete)="onNdgDataComplete($event)"></ndg-data-giu>
            </mat-tab>

            <!-- NEEDS -->
            <mat-tab label="{{ 'survey.new.needs-giu.title' | translate }}" [disabled]="true">
                <needs-giu *ngIf="surveyId" [surveyId]="surveyId" (complete)="onNeedsComplete($event)"></needs-giu>
            </mat-tab>

            <!-- SAVINGS -->
            <mat-tab label="{{ 'survey.new.savings.title' | translate }}" [disabled]="true" *ngIf="surveyNeedsEmit?.savings">
                <savings [surveyId]="surveyId" [surveyNeeds]="surveyNeedsEmit" [ndgData]="ndgDataEmit" (complete)="onSavingsComplete()"></savings>
            </mat-tab>

            <!-- SAVINGS SHORT LIST -->
            <mat-tab label="{{ 'survey.new.savings-short-list.title' | translate }}" [disabled]="true" *ngIf="surveyNeedsEmit?.savings && savingsCompleted">
                <savings-short-list [surveyId]="surveyId" (complete)="onSavingsShortListComplete()"></savings-short-list>
            </mat-tab>
        </div>

        <!-- FINAL -->
        <mat-tab label="{{ 'survey.new.final.title' | translate }}" [disabled]="true">
            <final *ngIf="surveyId" [surveyId]="surveyId" (complete)="onSurveyCompleted($event)"></final>
        </mat-tab>
    </mat-tab-group>
</form>
